import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { API, Auth } from "aws-amplify";
import ReactExport from "react-data-export";
import { format } from "date-fns";
import {
  reinstallments,
  calcuratorInterestTwo,
} from "../../utils/reinstallments";
import { calReportAging } from "../../utils/calReportAging";
import { pad } from "utils/getLocalDateTime";
import { getCurrentLocalDateTime } from "utils/getLocalDateTime";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function DebtorErrorExport({ selectToday }) {
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [dataDebtor, setDataDebtor] = useState([]);

  useEffect(() => {
    if (dataDebtor.length > 0) {
      const getExportId = document.getElementById("export-excel-debtor-error");
      getExportId.click();
    }
  }, [dataDebtor]);

  const getLastItem = (lastItem) => {
    let lastItemStr = "";
    if (lastItem) {
      const lastItemKeys = Object.keys(lastItem);
      lastItemKeys.forEach((key) => {
        lastItemStr += `${key}=${lastItem[key]}&`;
      });
    }
    return lastItemStr;
  };

  const onClickAging = async () => {
    try {
      setLoading(true);

      let data = {};
      let localCount = 0;
      let lastItem = null;
      let keepLoan = [];

      do {
        data = await API.get("MoneyHubAdmin", "/loan/debtorError", {
          queryStringParameters: {
            selectDate: selectToday,
            ExclusiveStartKey: getLastItem(lastItem),
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        lastItem = data?.lastItem;
        localCount += data?.items.length;
        keepLoan.push(...data?.items);
        setCount(localCount);
      } while (lastItem);

      setDataDebtor(keepLoan);
    } catch (error) {
      console.log("loading error", error);
    } finally {
      setLoading(false);
    }
  };

  const createDataWithStyle = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    var filled = { fgColor: { rgb: "FFFFFF" } };
    let style = { borders, font: { sz: 14 }, alignment: "right", fill: filled };

    for (let i = 0; i < data.length; i++) {
      result.push([
        { value: `${data[i]["Cardno"]}`, style },
        { value: `${data[i]["Employer"]}`, style },
        { value: `${data[i]["ReceivedDate"]}`, style },
        { value: `${data[i]["SendDate"]}`, style },
        { value: `${data[i]["DebtType"]}`, style },
        { value: `${data[i]["Name"]}`, style },
        { value: `${data[i]["IdCard"]}`, style },
        { value: `${data[i]["BirthDay"]}`, style },
        { value: `${data[i]["OSBal"]}`, style },
        { value: `${data[i]["LastPayAmount"]}`, style },
        { value: `${data[i]["LastPayDate"]}`, style },
        { value: `${data[i]["ProductName"]}`, style },
        { value: `${data[i]["ProductCode"]}`, style },
        { value: `${data[i]["Block"]}`, style },
        { value: `${data[i]["DPD"]}`, style },
        { value: `${data[i]["Cycle"]}`, style },
        { value: `${data[i]["Bucket"]}`, style },
        { value: `${data[i]["Current"]}`, style },
        { value: `${data[i]["xDay"]}`, style },
        { value: `${data[i]["x30Day"]}`, style },
        { value: `${data[i]["x60Day"]}`, style },
        { value: `${data[i]["x90Day"]}`, style },
        { value: `${data[i]["x120Day"]}`, style },
        { value: `${data[i]["x150Day"]}`, style },
        { value: `${data[i]["x180Day"]}`, style },
        { value: `${data[i]["x210Day"]}`, style },
        { value: `${data[i]["DueDate"]}`, style },
        { value: `${data[i]["TotalDue"]}`, style },
        { value: `${data[i]["occupation"]}`, style },
        { value: `${data[i]["NumberOfInstallmentPeriod"]}`, style },
        { value: `${data[i]["NumberOfPaidInstallments"]}`, style },
        { value: `${data[i]["Principle"]}`, style },
        { value: `${data[i]["InterestRate"]}`, style },
        { value: `${data[i]["Interest"]}`, style },
        { value: `${data[i]["Mulct"]}`, style },
        { value: `${data[i]["TrackValue"]}`, style },
        { value: `${data[i]["LegalCode"]}`, style },
        { value: `${data[i]["ProductType"]}`, style },
        { value: `${data[i]["FirstDueDate"]}`, style },
        { value: `${data[i]["LastDueDate"]}`, style },
        { value: `${data[i]["NumberOfUnPaidInstallments"]}`, style },
        { value: `${data[i]["LateCharge"]}`, style },
        { value: `${data[i]["WODate"]}`, style },
        { value: `${data[i]["OaFlag"]}`, style },
        { value: `${data[i]["OsAfter"]}`, style },
        { value: `${data[i]["OsBefore"]}`, style },
        { value: `${data[i]["GroupType"]}`, style },
        { value: `${data[i]["AddFlag"]}`, style },
        { value: `${data[i]["CradieLim"]}`, style },
        { value: `${data[i]["ClosingAccount"]}`, style },
        { value: `${data[i]["TdrDate"]}`, style },
        { value: `${data[i]["PercentPenaltyInt"]}`, style },
        { value: `${data[i]["ExpirationDate"]}`, style },
        { value: `${data[i]["NextDueDate"]}`, style },
        { value: `${data[i]["NextDueAMT"]}`, style },
        { value: `${data[i]["BillingAddress"]}`, style },
        { value: `${data[i]["CompanyAddress"]}`, style },
        { value: `${data[i]["HomeAddress"]}`, style },
        { value: `${data[i]["TelNos"]}`, style },
      ]);
    }
    return result;
  };

  const multiDataSet = [
    {
      columns: [
        {
          title: "Cardno",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "Employer",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "ReceivedDate",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "SendDate",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "DebtType",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "Name",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "IdCard",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "BirthDay",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "OSBal",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "LastPayAmount",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "LastPayDate",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "ProductName",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "ProductCode",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "Block",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "DPD",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "Cycle",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "Bucket",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "Current",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "xDay",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "x30Day",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "x60Day",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "x90Day",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "x120Day",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "x150Day",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "x180Day",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "x210Day",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "DueDate",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "TotalDue",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "occupation",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "NumberOfInstallmentPeriod",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "NumberOfPaidInstallments",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "Principle",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "InterestRate",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "Interest",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "Mulct",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "TrackValue",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "LegalCode",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "ProductType",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "FirstDueDate",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "LastDueDate",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "NumberOfUnPaidInstallments",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "LateCharge",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "WODate",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "OaFlag",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "OsAfter",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "OsBefore",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "GroupType",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "AddFlag",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "CradieLim",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "ClosingAccount",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "TdrDate",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "PercentPenaltyInt",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "ExpirationDate",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "NextDueDate",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "NextDueAMT",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "BillingAddress",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "CompanyAddress",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "HomeAddress",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
        {
          title: "TelNos",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        },
      ],
      data: createDataWithStyle(dataDebtor),
    },
  ];

  return (
    <div>
      <ExcelFile
        filename={`REPORT_DEBTOR_ERROR_${format(new Date(selectToday), "yyyy-MM-dd")}`}
        element={<button id="export-excel-debtor-error" hidden></button>}
      >
        <ExcelSheet dataSet={multiDataSet} name="DebtorError"></ExcelSheet>
      </ExcelFile>
      <button
        disabled={loading}
        className={classNames(
          "p-4  text-white mt-2 flex flex-row rounded-lg items-center w-full",
          {
            "bg-green-500": !loading,
            "bg-gray-400": loading,
          }
        )}
        onClick={onClickAging}
      >
        {loading && (
          <svg
            className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx={12}
              cy={12}
              r={10}
              stroke="currentColor"
              strokeWidth={4}
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        )}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
          />
        </svg>
        {count > 0 && `(${count})`} Debtor Error Report
      </button>
    </div>
  );
}

export default DebtorErrorExport;
